let timeout: NodeJS.Timeout

export const debounce = <F extends (...args: any[]) => any>(callback: F, waitTime: number) => {
  return (...args: Parameters<F>): Promise<ReturnType<F>> =>
    new Promise((resolve) => {
      if (timeout) {
        clearTimeout(timeout)
      }

      timeout = setTimeout(() => resolve(callback(...args)), waitTime)
    })
}
